<template>
  <div class="qr-card" :class="{ 'qr-card-flat': flat }" :style="width ? `width: ${width}px` : ''">
    <div class="qrcode-migly" ref="container">
      <div class="qr-frame">
        <v-img :src="base64" class="qr-image"/>
        <div class="qr-frame-loading" v-if="!base64">
          <v-progress-circular indeterminate size="26" width="2" color="#0277BD"/>
        </div>
      </div>
      <!-- <vue-qr :text="`${value}?s=q`" logoSrc="/images/logo/logo-05.png" backgroundDimming="#fff" :margin='0' :callback="load" :logoCornerRadius="10"/> -->
      <div ref="qrcode" v-show="false"></div>
    </div>
    <a download="migly-qrcode" :href="base64" class="qr-download-btn" v-if="enableControlls">
      <v-icon size="16" color="#0277BD" class="mr-1">mdi-download</v-icon>
      {{ $t('downloadQrCode') }}
    </a>
  </div>
</template>
<script>
import QRCodeStyling from 'qr-code-styling';
  export default {
    name: 'QRCodeMigly',
    props: ['value', 'enableControlls', 'width', 'border', 'data'],
    components: {
    },
    data: () => ({
      base64: null,
      qrCode: null,
    }),
    mounted: function() {
      this.qrCode = new QRCodeStyling({
        width: 500,
        height: 500,
        data: `${this.value}?s=q`, // URL ou texto que você deseja codificar
        // image: "/images/logo/logo-05.png", // Caminho para o logo da sua empresa
        dotsOptions: {
          color: "#000", // Cor dos pontos
          type: "rounded", // Define os pontos como redondos
        },
        cornersSquareOptions: {
          color: "#000", // Cor dos cantos
          type: "extra-rounded", // Deixa os cantos ainda mais arredondados
        },
        backgroundOptions: {
          color: "#ffffff", // Cor de fundo
        },
        imageOptions: {
          crossOrigin: "anonymous",
          // margin: 20, // Margem ao redor do logo
        },
      });

      this.qrCode.append(this.$refs.qrcode);

      // Adiciona um círculo no meio do QR Code
      this.addCircleToCenter();

      
    },
    computed: {
      flat: function() {
        return `${this.border}` === '0'
      }
    },
    methods: {
      load: function (data) {
         this.src = data
         if(this.data)
          this.data.base64 = data
      },
      getQRCodeBase64() {
        const canvas = this.$refs.qrcode.querySelector("canvas");
        if (canvas) {
          this.base64 = canvas.toDataURL("image/png"); // Obtém o Base64 do canvas
        }
      },
      addCircleToCenter() {
        // Usa um pequeno timeout para garantir que o QR Code foi renderizado antes de desenhar o círculo
        setTimeout(() => {
          const canvas = this.$refs.qrcode.querySelector("canvas");
          if(this.logo)
            if (canvas) {
              const ctx = canvas.getContext("2d");


              
              // Define as propriedades do círculo
              const centerX = canvas.width / 2;
              const centerY = canvas.height / 2;
              const radius = canvas.width / 8; // Tamanho do círculo (10% do tamanho do QR Code)

              // Desenha o círculo
              ctx.beginPath();
              ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
              ctx.fillStyle = "#000"; // Cor de preenchimento do círculo (ajuste conforme necessário)
              ctx.fill();

              // Adiciona uma borda no círculo (opcional)
              ctx.lineWidth = 6;
              ctx.strokeStyle = "#FFF"; // Cor da borda do círculo
              ctx.stroke();

              // Carrega a logo da URL
              const logo = new Image();
              logo.src = this.logo ? this.logo : '/images/logo/logo-02.png' //this.logoUrl;
              logo.crossOrigin = "anonymous"; // Para evitar problemas de CORS
              logo.onload = () => {
                const logoSize = radius * 2; // Tamanho do logo
                const startX = centerX - logoSize / 2; // Posição X para centralizar
                const startY = centerY - logoSize / 2; // Posição Y para centralizar
                
                // Preenche o círculo
                ctx.beginPath();
                ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
                ctx.closePath();
                ctx.clip(); // Faz o canvas só desenhar dentro do círculo

                // Desenha a imagem no círculo
                ctx.drawImage(logo, startX, startY, logoSize, logoSize);
                
                // Restaura o canvas para permitir desenhar fora do círculo
                ctx.restore();
              };
              logo.onerror = () => {
                console.error("Erro ao carregar a imagem da logo.");
              };
            }
          setTimeout(() => {
            this.getQRCodeBase64()
          }, 100);
        }, 100); // Timeout para garantir que o QR code foi renderizado
      }
    },
  }
</script>
<style scoped>
.qr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  font-family: 'Montserrat', sans-serif;
}
.qr-card:not(.qr-card-flat) {
  background: #FFFFFF;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 14px 30px rgba(16,24,39,0.09);
}
.qrcode-migly {
  width: 100%;
}
.qr-frame {
  position: relative;
  background: #FFFFFF;
  border-radius: 0.9rem;
  border: 1px solid rgba(16,24,39,0.08);
  overflow: hidden;
  aspect-ratio: 1;
}
.qr-card-flat .qr-frame {
  border-color: rgba(16,24,39,0.06);
}
.qr-image ::v-deep img {
  width: 100% !important;
}
.qr-frame-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #E3F1FA;
  color: #0277BD;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0.55rem 1.1rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.qr-download-btn:hover {
  background: #DDEBFA;
  transform: translateY(-1px);
}
</style>